module.exports = __webpack_public_path__ + "img/主要功能-ras@2x.22b1b14d.png";